export type Lead = {
    id: number, 
    organizationId: number | null,
    organizationName: string | null,
    name: string,
    firstName: string,
    middleName: string,
    lastName: string,
    role: string, 
    email: string, 

    website: string,
    industry: string,
    source: string,
    status: string,
    referredBy: string,
    referredByName: string,
    userResponsible1: string,
    userResponsible1Name: string,
    userResponsible2: string,
    userResponsible2Name: string,

    businessPhone: string, 
    extension: string,
    fax: string,
    street: string,
    city: string,
    state: string,
    zipCode: string,
    overseaAddress: string,
    background: string,
    voidReason: string,
    validateReason: string,
    sent: number | boolean,
    realSent: number | boolean,
    creatorId: string, 
    creatorName: string,
    createdAt: string, 
    updaterId: string,
    updaterName: string,
    updatedAt: string,
    void: "yes" | "no", 
    mobile: string,  
};
export const statusOptions = [
    "Not Contacted",
    "Contacted",
    "Converted",
    "Disqualified"
];
export const sourceOptions =  [
    "Outreach",
    "Patrner Referral",
    "Phone Enquiry",
    "Web",
    "Others"
]
